<template>
  <sidebar
    :addTitle="$t('GradeControl.MuckType.AddNew')"
    :editTitle="$t('GradeControl.MuckType.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.MuckType.Name')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.MuckType.Name')"
                v-model="muckTypeName"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.MuckType.Code')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.MuckType.Code')"
                v-model="muckTypeCode"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.MuckType.Factor')" rules="required|decimal:5|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.MuckType.Factor')"
                v-model="muckTypeFactor"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('GradeControl.MuckType.Comments')}} </form-label>
            <vs-textarea 
            v-model="muckTypeComments" 
            class="w-full"  
            name="muckTypeComments" />
          </vs-col>
        </vs-row> 
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../../shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar
  },
  data() {
    return {
      muckTypeId: 0,
      muckTypeName: "",
      muckTypeCode: "",
      muckTypeFactor: 0,
      muckTypeComments: ""
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { muckTypeId, name, code, factor, comments } = JSON.parse(JSON.stringify(this.data));
      this.muckTypeId = muckTypeId;
      this.muckTypeName = name;
      this.muckTypeCode = code;
      this.muckTypeFactor = factor;
      this.muckTypeComments = comments;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.muckTypeCode = "";
      this.muckTypeName = "";
      this.muckTypeId = 0;
      this.muckTypeFactor = 0;
      this.muckTypeComments = "";
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            muckTypeId: this.muckTypeId,
            code: this.muckTypeCode,
            name: this.muckTypeName,
            factor : this.muckTypeFactor,
            comments : this.muckTypeComments,
            projectId: this.projectId
          };

          this.$vs.loading();
          if (this.muckTypeId !== null && this.muckTypeId > 0) {
            this.$store.dispatch("gradeControl/updateMuckType", obj).then(() => {
              this.$emit("onMuckTypeUpdated", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("gradeControl/addMuckType", obj).then(() => {
              this.$emit("onMuckTypeInserted", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
